/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApiResponseListAgentGroupMemberCandidate } from '../../models/api-response-list-agent-group-member-candidate';

export interface GetMemberCandidates$Params {
  'x-api-requestId'?: string;
  'x-api-canal'?: string;
}

export function getMemberCandidates(http: HttpClient, rootUrl: string, params?: GetMemberCandidates$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseListAgentGroupMemberCandidate>> {
  const rb = new RequestBuilder(rootUrl, getMemberCandidates.PATH, 'get');
  if (params) {
    rb.header('x-api-requestId', params['x-api-requestId'], {});
    rb.header('x-api-canal', params['x-api-canal'], {});
  }

  return http.request(
    rb.build({ responseType: 'blob', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ApiResponseListAgentGroupMemberCandidate>;
    })
  );
}

getMemberCandidates.PATH = '/v1/api/ui/agent-groups/member-candidates';
